import { render, staticRenderFns } from "./BackgroundInfoModal.vue?vue&type=template&id=1ea86b04&scoped=true&"
import script from "./BackgroundInfoModal.vue?vue&type=script&lang=ts&"
export * from "./BackgroundInfoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea86b04",
  null
  
)

export default component.exports